import { Injectable } from '@angular/core';
import { delay, map, Observable, of } from 'rxjs';
import {
  CompetitionStatus,
  CUP_ADD_ENTRANT,
  CUP_CREATE,
  CUP_DELETE_ENTRANT,
  CUP_GET_ROUNDS,
  CupRound,
  Format,
  KnockoutCompetition,
} from '@pool-league/shared-data-api';
import { PoolLeagueApiClient } from '../base-client/pool-league-api-client';
import { CupTracks } from './tracks';

@Injectable({
  providedIn: 'root',
})
export class CupApiClient extends PoolLeagueApiClient {
  getRounds(seasonId: string, format: Format): Observable<CupTracks> {
    return this.buildRequest(CUP_GET_ROUNDS, { seasonId, format })
      .get<{ rounds: CupRound[] }>()
      .pipe(
        map(({ rounds }) =>
          rounds.reduce<CupTracks>((tracks, next) => {
            const nextTrackId = next.id.charAt(0);
            if (
              !tracks.length ||
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              tracks[tracks.length - 1]!.id !== nextTrackId
            ) {
              tracks.push({
                id: nextTrackId,
                rounds: [next],
              });
            } else {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              tracks[tracks.length - 1]!.rounds.push(next);
            }
            return tracks;
          }, []),
        ),
      );
  }

  createCup(cupDetails: {
    seasonId: string;
    format: Format;
    elimination: KnockoutCompetition['elimination'];
  }): Observable<KnockoutCompetition> {
    return this.buildRequest(CUP_CREATE, cupDetails).put<KnockoutCompetition>({
      elimination: cupDetails.elimination,
    });
  }

  addEntrant(
    seasonId: string,
    format: Format,
    entrantId: string,
  ): Observable<string[]> {
    return this.buildRequest(CUP_ADD_ENTRANT, { seasonId, format }).post<
      string[]
    >({ entrantId });
  }

  removeEntrant(
    seasonId: string,
    format: Format,
    entrantId: string,
  ): Observable<string[]> {
    return this.buildRequest(CUP_DELETE_ENTRANT, {
      seasonId,
      format,
      entrantId,
    }).delete<string[]>();
  }

  setStatus(
    seasonId: string,
    format: Format,
    status: CompetitionStatus,
  ): Observable<KnockoutCompetition> {
    // TODO
    void [seasonId, format];
    // return a KnockoutCompetition ?
    // What about the round info ?
    // return throwError(() => new HttpErrorResponse({status: 409})).pipe(
    //   httpRequestStates(),
    // );
    return of<KnockoutCompetition>({
      elimination: 'D',
      status,
      entrants: [],
    }).pipe(delay(800));
  }
}
